import Tab from "./Tab.vue";

export default Tab;
